import React from 'react';
import type { HeatmapCell } from '../../../../shared/lib/insights';

/**
 * Chunky pixel-art activity heatmap (Forge Wrapped). Weeks as columns, days as
 * rows — like a GitHub contribution grid but in the blocky style of the usage
 * card. Intensity 0-4 maps to a blue ramp; cells carry a native title tooltip.
 */
const FILL = ['var(--hm-0)', 'var(--hm-1)', 'var(--hm-2)', 'var(--hm-3)', 'var(--hm-4)'];

export const ActivityHeatmap: React.FC<{ cells: HeatmapCell[] }> = ({ cells }) => {
  // cells are oldest→newest; chunk into weeks of 7 (columns), pad the first
  // week so the last cell lands bottom-right.
  const cols: HeatmapCell[][] = [];
  for (let i = 0; i < cells.length; i += 7) cols.push(cells.slice(i, i + 7));

  const SIZE = 13, GAP = 4, R = 3;
  const width = cols.length * (SIZE + GAP);
  const height = 7 * (SIZE + GAP);

  return (
    <div data-testid="activity-heatmap" className="overflow-x-auto">
      <style>{`
        :root {
          --hm-0: #e8edf2; --hm-1: #bcd2f0; --hm-2: #7faaf0; --hm-3: #3b76e0; --hm-4: #1f4fc4;
        }
      `}</style>
      <svg width={width} height={height} role="img" aria-label="Agent activity over the last 10 weeks">
        {cols.map((week, c) =>
          week.map((cell, r) => (
            <rect
              key={cell.date}
              x={c * (SIZE + GAP)}
              y={r * (SIZE + GAP)}
              width={SIZE}
              height={SIZE}
              rx={R}
              fill={FILL[cell.intensity]}
            >
              <title>{`${cell.date}: ${cell.count} agent run${cell.count === 1 ? '' : 's'}`}</title>
            </rect>
          )),
        )}
      </svg>
    </div>
  );
};

export default ActivityHeatmap;
